/* Metadatos + helpers para el modulo Vencimientos.
   Adaptados del handoff a NUESTROS estados/tipos (espanol MX) y al contrato
   del backend real (GET /seguros-dashboard/vencimientos). */

/* ── Estados del backend -> badge ──────────────────────────────────────────
   estado posibles: por_vencer | vencido | pagado | programado | condonado |
                    renovado | cancelado     (+ needs_review como flag aparte) */
export const STATUS_META = {
  pagado: { label: 'Pagado', icon: 'pi-check-circle', tone: 'success' },
  renovado: { label: 'Renovado', icon: 'pi-check-circle', tone: 'success' },
  vigente: { label: 'Vigente', icon: 'pi-check-circle', tone: 'success' },
  por_vencer: { label: 'Por vencer', icon: 'pi-clock', tone: 'warning' },
  vencido: { label: 'Vencido', icon: 'pi-exclamation-triangle', tone: 'danger' },
  programado: { label: 'Programado', icon: 'pi-calendar', tone: 'neutral' },
  condonado: { label: 'Condonado', icon: 'pi-minus-circle', tone: 'muted' },
  cancelado: { label: 'Cancelado', icon: 'pi-times-circle', tone: 'muted' },
};

export const REVIEW_META = { label: 'Revisar', icon: 'pi-flag', tone: 'review' };

/* ── Tipos -> icono/color (gps NO se muestra aun) ────────────────────────── */
export const TYPE_META = {
  seguro: { label: 'Seguro', icon: 'pi-shield', toneClass: 'tico-seguro' },
  placa: { label: 'Placas', icon: 'pi-credit-card', toneClass: 'tico-tarjeta' },
  tenencia: { label: 'Tenencia', icon: 'pi-receipt', toneClass: 'tico-tenencia' },
  renta: { label: 'Renta', icon: 'pi-wallet', toneClass: 'tico-renta' },
};

/* ── Helpers de formato (es-MX) ────────────────────────────────────────── */
const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

export const MONTHS_FULL = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

// Acepta 'YYYY-MM-DD'; otra cosa -> null (fila dudosa).
export function parseDate(s) {
  if (!s || s === '—') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) return null;
  return new Date(+m[1], +m[2] - 1, +m[3], 12);
}

export function fmtDate(s) {
  const d = parseDate(s);
  if (!d) return s || '—';
  return `${String(d.getDate()).padStart(2, '0')} ${MONTHS[d.getMonth()]} ${String(d.getFullYear()).slice(2)}`;
}

// Monto: number|null -> "$X,XXX.XX" o "—"
export function fmtMoney(n, moneda = 'MXN') {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  const formatted = Number(n).toLocaleString('es-MX', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  const symbol = moneda && moneda !== 'MXN' ? `${moneda} $` : '$';
  return `${symbol}${formatted}`;
}

// Texto relativo a partir de dias_para_vencer (number|null) del backend.
export function relDaysLabel(dias, estado) {
  if (estado === 'pagado' || estado === 'renovado' || estado === 'condonado' || estado === 'cancelado') return null;
  if (dias === null || dias === undefined) return { text: 'fecha por revisar', cls: 'urgent' };
  if (dias < 0) return { text: `hace ${Math.abs(dias)} d`, cls: 'over' };
  if (dias === 0) return { text: 'hoy', cls: 'urgent' };
  if (dias <= 30) return { text: `en ${dias} d`, cls: 'urgent' };
  return { text: `en ${dias} d`, cls: '' };
}

export function statusMeta(estado, needsReview) {
  if (needsReview) return REVIEW_META;
  return STATUS_META[estado] || { label: estado || '—', icon: 'pi-circle', tone: 'neutral' };
}

/* El detalle (GET /cliente) devuelve el status CRUDO de la prima
   (paid/pending/overdue/scheduled/waived/cancelled). Lo mapeamos al estado en
   espanol del badge, igual que hace el backend en el feed. */
export function mapPrimaStatus(status, dueDate) {
  if (status === 'paid') return 'pagado';
  if (status === 'waived') return 'condonado';
  if (status === 'scheduled') return 'programado';
  if (status === 'cancelled') return 'cancelado';
  // pending / overdue -> por fecha
  const d = parseDate(dueDate);
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  if (d && d < hoy) return 'vencido';
  return 'por_vencer';
}

/* effective_status (active/expired/cancelled/renewed/...) -> estado del badge. */
export function mapEffectiveStatus(es) {
  switch (es) {
    case 'active': return 'vigente';
    case 'expired': return 'vencido';
    case 'cancelled': return 'cancelado';
    case 'suspended': return 'cancelado';
    case 'renewed': return 'renovado';
    case 'pending_activation': return 'programado';
    default: return es;
  }
}
